/**
 * `?area=` / `?capability=` deep links for the Product Map page — so
 * `/lookup/$id` on a `parea_…`/`pcap_…` id can land on the right row (and, for
 * a capability, open its drawer). Follows `features/planning/planningRouteSearch.ts`.
 *
 * @module features/product-map/productMapRouteSearch
 */

export type ProductMapViewMode = 'list' | 'explore';

export type ProductMapSearch = {
  area?: string;
  capability?: string;
  propertyId?: string;
  /** List | Explore view switcher — shareable so a link can land on either. Undefined defers to the persisted preference. */
  view?: ProductMapViewMode;
};

function parseId(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

function parseView(value: unknown): ProductMapViewMode | undefined {
  return value === 'list' || value === 'explore' ? value : undefined;
}

export function validateProductMapSearch(search: Record<string, unknown>): ProductMapSearch {
  return {
    area: parseId(search.area),
    capability: parseId(search.capability),
    propertyId: parseId(search.propertyId),
    view: parseView(search.view),
  };
}
